module.exports = __webpack_public_path__ + "static/hse-61b236153bdd7bb4f2495585ecaa7485.mp4";